import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

var INITIAL_CONTEXT = {
  calendarMode: "day",
  currentDateTimestamp: Date.now(),
  daysInMonth: 1,
  firstDayOfMonth: 1,
  selectedDateValue: Date.now().valueOf(),
  setSelectedDateValue: function setSelectedDateValue(date) {},
  setCalendarMode: function setCalendarMode(mode) {},
  onNext: function onNext() {},
  onPrev: function onPrev() {}
};
var CalendarContext = /*#__PURE__*/React__default.createContext(INITIAL_CONTEXT);
var useCalendarContext = function useCalendarContext() {
  return React__default.useContext(CalendarContext);
};
var CalendarContextProvider = function CalendarContextProvider(_ref) {
  var calendarModeProp = _ref.calendarMode,
    initSelectedDateValue = _ref.initSelectedDateValue,
    children = _ref.children;
  var _React$useState = React__default.useState(calendarModeProp !== null && calendarModeProp !== void 0 ? calendarModeProp : INITIAL_CONTEXT.calendarMode),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    calendarMode = _React$useState2[0],
    setCalendarMode = _React$useState2[1];
  var _React$useState3 = React__default.useState(new Date(new Date().setHours(0, 0, 0, 0))),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    currentDate = _React$useState4[0],
    setCurrentDateState = _React$useState4[1];
  var _React$useState5 = React__default.useState(initSelectedDateValue !== null && initSelectedDateValue !== void 0 ? initSelectedDateValue : currentDate.valueOf()),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    selectedDateValue = _React$useState6[0],
    setSelectedDateValueState = _React$useState6[1];
  var setCurrentDate = React__default.useCallback(function (date) {
    setCurrentDateState(new Date(date.setHours(0, 0, 0, 0)));
  }, []);
  var setSelectedDateValue = React__default.useCallback(function (value) {
    setSelectedDateValueState(new Date(new Date(value).setHours(0, 0, 0, 0)).valueOf());
  }, []);
  var dateCollection = React__default.useMemo(function () {
    var daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    var firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
    return [currentDate.valueOf(), daysInMonth, firstDayOfMonth];
  }, [currentDate]);
  var handlePrev = React__default.useCallback(function () {
    switch (calendarMode) {
      case "day":
        setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() - 1)));
        break;
      case "week":
        setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() - 7)));
        break;
      case "month":
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
        break;
    }
    setSelectedDateValue(Date.now());
  }, [calendarMode, currentDate]);
  var handleNext = React__default.useCallback(function () {
    switch (calendarMode) {
      case "day":
        setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() + 1)));
        break;
      case "week":
        setCurrentDate(new Date(currentDate.setDate(currentDate.getDate() + 7)));
        break;
      case "month":
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
        break;
    }
    setSelectedDateValue(Date.now());
  }, [calendarMode, currentDate]);
  return jsx(CalendarContext.Provider, {
    value: {
      calendarMode: calendarMode,
      selectedDateValue: selectedDateValue,
      setSelectedDateValue: setSelectedDateValue,
      currentDateTimestamp: dateCollection[0],
      daysInMonth: dateCollection[1],
      firstDayOfMonth: dateCollection[2],
      setCalendarMode: setCalendarMode,
      onNext: handleNext,
      onPrev: handlePrev
    },
    children: children
  });
};

export { CalendarContextProvider, useCalendarContext };
